.gridAndTable {
    margin: auto;
    max-width: 1300px;
    padding: 20px;
}

.filtersAndSwitchView {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    max-width: 1300px;
}

.filters {
    width: 100%;
}

.switchView {
    display: flex;
    align-items: flex-end;
}

 .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 360px);
    gap: 20px;
    justify-content: space-around;
 }

 .table {    
    background-color: var(--hps-white);
    border-radius: 1rem;
    height: 100%;
    padding: 20px;
    width: 100%;
}